//LIBRERIES
import { useI18n } from 'vue-i18n';
import { i18n } from '../lang/index';
import * as input from "../node_modules/saviafront/lib/js/compiled/md-input-module";
import * as radio from "../node_modules/saviafront/lib/js/compiled/md-radio-module.js";
import * as select from "../node_modules/saviafront/lib/js/compiled/md-select-module.js";
import * as imageCompressor from "../node_modules/saviafront/lib/js/compiled/imageCompressor.js";
import * as dropdown from "../node_modules/saviafront/lib/js/compiled/dropdown.js"
import * as notification from '../node_modules/saviafront/lib/js/compiled/notification';
import moment from "../node_modules/moment/moment.js";
import { createApp, reactive, ref, computed, nextTick, defineComponent, onMounted, onBeforeUpdate, Ref, toRefs } from 'vue';
import DatePicker from '@vuepic/vue-datepicker';
import draggable from 'vuedraggable';

// MODELS
import { App } from "../domain/App";
import { Wizard } from "../domain/entities/inscription/Wizard";
import { Inscription } from "../domain/entities/inscription/Inscription";
import { Gender } from "../domain/enum/Gender";
import { Languages } from "../domain/enum/Languages";
import { Cookie } from "../domain/Cookie";
import { InscriptionTurn } from "../domain/enum/InscriptionTurn";
import { ReserveType } from "../domain/enum/ReserveType";
import { FamilyType } from "../domain/enum/FamilyType";
import { PayExemptionTypes } from "../domain/enum/PayExemptionTypes";
import { StepGroupTypes } from "../domain/enum/StepGroupTypes";
import { MeritGroupType } from "../domain/enum/MeritGroupType";
import { FileTypes } from "../domain/enum/FileTypes";
import { InscriptionFile } from "../domain/entities/inscription/InscriptionFile";
import { ProcessType } from "../domain/enum/ProcessType";
import { MeritRatingType } from "../domain/enum/MeritRatingType";
import { BaseMeritsType } from "../domain/enum/BaseMeritsType";
import { PaymentMethod } from "../domain/enum/PaymentMethod";
import { Constants } from "../domain/enum/Constants";
import { StepTypes } from "../domain/enum/StepTypes";
import { PaymentType } from "../domain/enum/PaymentType";
import { AdminPreviewInscriptionMeritStep } from "../domain/entities/step/AdminPreviewInscriptionMeritStep";
import { PostMeritStep } from "../domain/entities/step/PostMeritStep";
import { MeritDocumentPostInscription } from "../domain/entities/merit/MeritDocumentPostInscription";
import { PaymentDataGttCaixa } from "../domain/entities/inscriptionStructure/PaymentDataGttCaixa";
import { PaymentDataRedsys } from "../domain/entities/inscriptionStructure/PaymentDataRedsys";
import { LegalStep } from "../domain/entities/step/LegalStep.js";
import { MultiLanguage } from "../domain/MultiLanguage.js";
import { AuthorizarionStep } from "../domain/entities/step/AuthorizarionStep.js";
import { PayExemptionStep } from "../domain/entities/step/PayExemptionStep.js";
import { ExamStep } from "../domain/entities/step/ExamStep.js";
import { Representative } from '../domain/Representative';
import ICommonDataState from '../domain/interfaces/ICommonDataState';
import { InscriptionDocument } from '../domain/entities/myInscription/InscriptionDocument';
import { ProcessInfoStep } from '../domain/entities/step/ProcessInfoStep';
import { ICallReference, IInscriptionReference } from '../domain/interfaces/IReference';
import { ReferencesFilters } from '../domain/entities/filter/IndexFilters';
import { Filter } from '../domain/entities/filter/Filter';

// APISERVICES
import * as InputService from "./services/InputService";
import * as OrderSelect from "./services/OrderSelect";
import * as MunicipalitiesService from "./services/MunicipalitiesService";
import { finishInscription, payInscription, getInscriptionStructure, getInscriptionById, postInscriptionAutoSave, getNewInscriptionId, getInscriptionPreview, getRedsysPaymentData, finishAttachMerits, attachMeritsFiles, getCaixaPaymentData, getIP, getInscriptionJustify } from "../infrastructure/apiServices/inscription.service";
import { addFileToInscription, removeFileFromInscription } from "../infrastructure/apiServices/file.service";
import { getMasterDataCountries, getMasterDataStreetTypes, getMasterDataProvinces, getMasterDataAutonomousCommunity, getMasterDataNationalities, getMasterDataMunicipalities, getProcessesConfigurationPayExemptionList, getProcessesConfigurationAuthorizationList, getHeaderConfiguration, getClientAvailableLanguajes, getFeatureFlag } from "../infrastructure/apiServices/masterData.service";
import DocumentService from "./services/DocumentService";
import { StepGroup } from '../domain/entities/step/StepGroup';
import { RepresentativeRepository } from '../infrastructure/repositories/RepresentativeRepository';

// COMPOSABLES
import { useCommonData } from "./composables/useCommonData"

// COMPONENTS
import MdCheckbox from './components/MdCheckbox/MdCheckbox.vue';
import SdFilter from './components/SdFilter/SdFilter.vue';

// TO DO REMOVE ANYS NEVERS ETC
export const InscriptionComponent = defineComponent({
  components: { DatePicker, draggable, MdCheckbox, SdFilter },
  setup() {
    // depenencies  
    const { t, locale } = useI18n();

    // states
    const commonDataState = reactive({
      headerConfig: {},
      availableLanguajes: { defaultLanguage: '', secondLanguage: '' },
      cookie: new Cookie(),
      app: new App(),
      locale
    });

    // computed properties    
    const breadcrumOrigin = computed(() => {
      return t(ProcessType.translations[state.processTypeSelected]);
    });

    const pageTitle = computed(() => '');

    const anyError = computed(() => {
      if (!state.wizard.structure) return false;
      return state.wizard.structure.some((group) =>
        group.steps.some((step) => step.error)
      );
    });

    const stepsWithError = computed(() => {
      let stepsError = 0;
      state.wizard.structure.forEach((group) => {
        stepsError += group.steps.filter((step) => step.error).length;
      });
      return stepsError;
    });

    const disabilityDocuments = computed(() => {
      return state.inscription.documents.filter(
        (doc) => doc.type === FileTypes.enum.DISABILITY
      );
    });

    const requirementDocuments = computed(() => {
      return state.inscription.documents.filter(
        (doc) => doc.type === FileTypes.enum.REQUIREMENT
      );
    });

    const meritDocuments = computed(() => {
      return state.inscription.documents.filter(
        (doc) => doc.type === FileTypes.enum.MERIT
      );
    });

    const examDocuments = computed(() => {
      return state.inscription.documents.filter(
        (doc) => doc.type === FileTypes.enum.CREDITABLEEXAMS
      );
    });

    const payExemptionDocuments = computed(() => {
      return state.inscription.documents.filter(
        (doc) => doc.type === FileTypes.enum.PAY_EXEMPTION
      );
    });

    const feePaymentDocuments = computed(() => {
      return state.inscription.paymentMethod === PaymentMethod.enum.OFFLINE ? state.inscription.documents.filter(
        (doc: { type: number, fileName: string }) => doc.type === FileTypes.enum.FEE_PAYMENT && doc.fileName) : [];
    });

    const disabilityTurnSelected = computed(() => {
      const turn = state.inscription.contactData.inscriptionTurn;
      return (
        turn === InscriptionTurn.enum.FREE_DISABILITY ||
        turn === InscriptionTurn.enum.INTERNAL_DISABILITY ||
        turn === InscriptionTurn.enum.FREE_DESIGNATION_DISABILITY
      );
    });

    const autonomousCommunityVissible = computed(() => {
      if (
        state.inscription.payExemption.payExemptionType !== PayExemptionTypes.enum.GENERALLARGEFAMILY &&
        state.inscription.payExemption.payExemptionType !== PayExemptionTypes.enum.SPECIALLARGEFAMILY
      ) {
        state.inscription.payExemption.autonomousCommunity = null;
      }
      return (
        state.inscription.payExemption.payExemptionType === PayExemptionTypes.enum.GENERALLARGEFAMILY ||
        state.inscription.payExemption.payExemptionType === PayExemptionTypes.enum.SPECIALLARGEFAMILY
      );
    });

    const isLoadingDocument = computed(() => {
      return state.inscription.documents.some((doc) => doc.loading);
    });

    const totalPoints = computed(() => {
      let totalPoints = 0;
      for (let i = 0; i < state.inscription.meritGroups.length - 1; i++) {
        totalPoints += state.inscription.meritGroups[i].totalGroupScore();
      }
      return Number(totalPoints.toFixed(6));
    });

    const currentLanguage = computed(() => {
      refreshStreeTypes();
      return commonDataState.locale;
    });

    const datepickerFormat = computed(() => {
      return (moment().locale(commonDataState.locale).localeData() as any)._longDateFormat[Constants.format.L];
    });

    const underSixteen = computed(() => {
      if (state.inscription.personalDataDetails.dateOfBirth) {
        return moment().diff(state.inscription.personalDataDetails.dateOfBirth, 'years') < Constants.minimumInscriptionCandidateAge;
      }
      return false;
    });

    const retirementAge = computed(() => {
      if (state.inscription.personalDataDetails.dateOfBirth) {
        return moment().diff(state.inscription.personalDataDetails.dateOfBirth, 'years') > Constants.maximumInscriptionCandidateAge;
      }
      return false;
    });

    const pricePayExemption = computed(() => {
      const paymentStepGroup = state.wizard.structure.find(stepGroup => stepGroup.type === StepGroupTypes.enum.PAYWIZARD);
      const userMustToPayOnline = state.inscription.processHasFeePayment && state.inscription.canBePaymentMethodOnline && paymentStepGroup !== undefined;

      if (!userMustToPayOnline) {
        return null;
      }

      const paymentStep: any = paymentStepGroup.steps.find((step: any) => step.type === StepTypes.enum.TAXPAYMENT);
      const newPricePayExemption = state.inscription.isPayExemptionTypeNoneOrNoReason()
        ? paymentStep.generalAmount
        : paymentStep.payExemptionFeeAmounts.find(payExemptionFeeAmount =>
          payExemptionFeeAmount.payExemptionType === state.inscription.payExemption.payExemptionType
        ).amount;
      state.inscription.setPaymentMethod(newPricePayExemption);
      return newPricePayExemption;
    });

    const lastLogin = computed(() => {
      return moment(commonDataState.app.profile.lastLogin[0]).format(commonDataState.app.formatDate) + ' ' + moment.utc(commonDataState.app.profile.lastLogin[0]).local().format('HH:mm:ss');
    });

    const filteredPaymentMethods = computed(() => {
      return Object.values(PaymentMethod.enum).filter((paymentMethod) => {
        return paymentMethod !== PaymentMethod.enum.NONE && !(paymentMethod === PaymentMethod.enum.OFFLINE && state.inscription.processPaymentType === PaymentType.enum.CREDIT_CARD);
      });
    });

    const filteredMerits = computed(() => {
      const meritsIndexStructure = state.wizard.getMeritsIndexStructure();
      const steps = state.wizard.structure[meritsIndexStructure].steps;

      return steps.filter((meritGroups, meritIndex) => {
        const currentStep = state.wizard.getStep(3, meritGroups.order);
        const isNotLastStep = meritIndex !== steps.length - 1;

        return (currentStep && isNotLastStep) || (currentStep && !state.wizard.hasAutoScaling);
      });
    });

    const examInscriptionSteps = computed(() => {
      return state.wizard.getStep(5, 0) ? state.wizard.structure[state.wizard.getExamsIndexStructure()].steps : [];
    });

    const filteredMeritGroupsForSummary = computed(() => {
      return state.inscription.meritGroups.slice(0, -1);
    });

    const referencesSorted = computed(() => {
      return isReferencesNotNull() && (state.wizard.getStep(0, 2) as ProcessInfoStep).references.length > 0 ? (state.wizard.getStep(0, 2) as ProcessInfoStep).references.sort((a: any, b: any) => {
        if (a.selected && b.selected) {
          return a.order - b.order;
        }
        return Number(b.selected) - Number(a.selected);
      }): [];
    });

    const selectedReferences = computed(() => {
      return isReferencesNotNull() && (state.wizard.getStep(0, 2) as ProcessInfoStep).references.length ? (state.wizard.getStep(0, 2) as ProcessInfoStep).references.filter((reference: any) => reference.selected) : [];
    });

    const hasInscriptionReferences = computed(() => {
      return isReferencesNotNull() && (state.wizard.getStep(0, 2) as ProcessInfoStep).references && (state.wizard.getStep(0, 2) as ProcessInfoStep).references.length > 0;
    });

    const referencesByTurn = computed(() => {
      return referencesSorted.value.filter(ref => ref.turn === state.inscription.contactData.inscriptionTurn);
    });

    const filteredReferences = computed({
      get: () => state.filter.filteredData(commonDataState.locale),
      set: (newData) => {
        state.filter.setData(newData);
      }
    });

    const referencesOnTurn = computed(() => {
      return isReferencesNotNull() && (state.wizard.getStep(0, 2) as ProcessInfoStep).references.length > 0 
        ? (state.wizard.getStep(0, 2) as ProcessInfoStep).getReferencesOnTurn() 
        : [];
    });

    const isInvalidReferencesCheckbox = computed(() => {
      return !state.inscription.references.length || state.inscription.references.length === 0;
    });

    // methods
    const changeLocal = (language) => {
      commonDataState.locale = language;
      commonDataState.app.changeLanguaje(language);
    };

    const saveCookies = () => {
      commonDataState.cookie.savePersonalizateCookies();
      showModalConfigurateCookies.value = false;
    };

    const closeModalConfigurateCookies = () => {
      showModalConfigurateCookies.value = false;
      showMandatoryCookies.value = false;
      showAnalysisCookies.value = false;
    };

    const acceptAllCookies = () => {
      commonDataState.cookie.acceptAllCookies();
    };

    const declineAllCookies = () => {
      commonDataState.cookie.declineAllCookies();
    };

    const refreshStreeTypes = () => {
      state.loadingStreetTypes = true;
      state.streetTypes = {};
      getMasterDataStreetTypes().then((responseDataStreetTypes: any) => {
        state.streetTypes = OrderSelect.prepareDataNotArray(responseDataStreetTypes.data);
        state.loadingStreetTypes = false;
        if (inscriptionForm) {
          nextTick(() => {
            InputService.checkValueAndUpdateInput(inscriptionForm.value);
          });
        }
      }).catch((error) => {
        console.error(error);
        state.loadingStreetTypes = false;
      });
    };

    const onDatePickerChange = (value) => {
      state.inscription.personalDataDetails.dateOfBirth = value;
      input.onDatePickerChange(value);
      saveDraft();
    };

    const onDatePickerTextChange = () => {
      const datepickerInput = document.getElementById(`dp-input-${datepickerOptions.uid}`) as any;
      if (datepickerInput && datepickerInput.value === '') {
        datepicker.value.closeMenu();
        state.inscription.personalDataDetails.dateOfBirth = {};
      }
      input.onDatePickerChange(datepickerInput.value);
      saveDraft();
    };

    const onInputDateFocus = () => {
      const datepicker = document.getElementById(`dp-input-${datepickerOptions.uid}`);
      input.onInputFocus(datepicker);
    };

    const onInputDateBlur = () => {
      const datepicker = document.getElementById(`dp-input-${datepickerOptions.uid}`);
      input.onInputBlur(datepicker);
      if (datepicker && !(datepicker as any).validity.valid) {
        return;
      }
      saveDraft();
    };

    const onInputFocus = ($event) => {
      input.onInputFocus($event.target);
    };

    const onInputBlur = ($event) => {
      input.onInputBlur($event.target);
      if (!$event.target.validity.valid) {
        return;
      }
      saveDraft();
    };

    const changedCountry = () => {
      nextTick(() => {
        InputService.checkValueAndUpdateInput(inscriptionForm.value);
      });
      saveDraft();
    };

    const changedProvince = () => {
      state.inscription.address.municipality = null;
      if (state.inscription.address.province) {
        nextTick(() => {
          state.municipalities = [];
          getMasterDataMunicipalities(state.inscription.address.province).then((municipalities: any) => {
            state.municipalities = MunicipalitiesService.setMunicipalities(municipalities.data, state.inscription.address.municipality);
          }).catch((error) => {
            console.error(error);
          });
        });
      }
      saveDraft();
    };

    const toShowSteps = () => {
      state.showSteps = !state.showSteps;
    };

    const openModalExit = () => {
      state.showExitModal = true;
    };

    const exitInscription = () => {
      location.href = 'index.html?type=' + state.processTypeSelected;
    };

    const manageDisability = () => {
      state.inscription.disabilityData.hasDisability = disabilityTurnSelected.value;
      saveDraft();
    };

    const onSelectFocus = ($event) => {
      select.onSelectFocus($event.target);
    };

    const onSelectBlur = ($event) => {
      select.onSelectBlur($event.target);
    };

    const onRadioClick = ($event) => {
      radio.onRadioClick($event.target);
      nextTick(() => {
        InputService.checkValueAndUpdateInput(inscriptionForm.value);
      });
      saveDraft();
    };

    const removeFileError = (fileErrorToRemove, comparatorId) => {
      let index = 0;
      if (fileErrorToRemove.evaluableConditionType === FileTypes.enum.REQUIREMENT) {
        index = state.filesError.findIndex(
          (file: { requirementId: string, fileName: string }) => file.requirementId === comparatorId && file.fileName === fileErrorToRemove.fileName
        );
      } else if (fileErrorToRemove.evaluableConditionType === FileTypes.enum.CREDITABLEEXAMS) {
        index = state.filesError.findIndex(
          (file: { examId: string, fileName: string }) => file.examId === comparatorId && file.fileName === fileErrorToRemove.fileName
        );
      } else if (fileErrorToRemove.evaluableConditionType === FileTypes.enum.MERIT) {
        index = state.filesError.findIndex(
          (file: { meritId: string, fileName: string }) => file.meritId === comparatorId && file.fileName === fileErrorToRemove.fileName
        );
      }
      state.filesError.splice(index, 1);
    };

    const validateFile = (file) => {
      if (Constants.fileImporter.INVALID_FILE_NAME.some((validFormat) => file.fileName.includes(validFormat))) {
        file.errors.push('lang.shared.fileName');
      }
      if (!Constants.fileImporter.VALID_EXTENSIONS.includes(file.extension.toLowerCase())) {
        file.errors.push('lang.shared.fileType');
      }
      if (file.size > Constants.fileImporter.MAX_SIZE_FILE) {
        file.errors.push('lang.shared.sizeFile');
      }
    };

    const addMultipleDocuments = async ($event, importer, type, requirementId = null, meritId = null, meritGroupId = null, examId = null, fileProperties = {} as any, meritSubGroupId = null) => {
      if (isPreview.value) {
        return;
      }

      let files = [] as any[];

      const idToRemoveFilesError = requirementId || meritId || examId;
      state.filesError = state.filesError.filter((file: any) => {
        return file.evaluableConditionType !== type ||
          (file.requirementId !== idToRemoveFilesError &&
            file.meritId !== idToRemoveFilesError &&
            file.examId !== idToRemoveFilesError);
      });

      if ($event.dataTransfer) {
        files = [...$event.dataTransfer.files];
      } else {
        files = [...importer.files];
      }

      if (files.length > 10) {
        fileProperties.dragging = false;
        fileProperties.maximumFilesExceeded = true;
        return;
      }

      fileProperties.maximumFilesExceeded = false;
      fileProperties.isAPdfPortfolio = false;
      fileProperties.fileEncrypted = false;

      for (let newFile of files) {
        if (type === FileTypes.enum.REQUIREMENT && requirementDocuments.value.some((doc) => newFile.name === doc.fileName && doc.requirementId === requirementId)) {
          continue;
        }
        if (type === FileTypes.enum.CREDITABLEEXAMS && examDocuments.value.some((doc) => newFile.name === doc.fileName && doc.examId === examId)) {
          continue;
        }
        if (type === FileTypes.enum.MERIT && meritDocuments.value.some((doc) => newFile.name === doc.fileName && doc.meritId === meritId)) {
          continue;
        }

        const file = {
          evaluableConditionType: type,
          requirementId: requirementId,
          examId: examId,
          meritSubGroupId: meritSubGroupId,
          meritGroupId: meritGroupId,
          meritId: meritId,
          fileName: (newFile as any).name,
          fileDate: moment.utc(),
          size: (newFile as any).size,
          extension: '.' + (newFile as any).name.split('.').pop(),
          loading: true,
          errors: []
        };

        if (file.extension.toLowerCase() === Constants.fileImporter.PDF_EXTENSION) {
          fileProperties.fileEncrypted = await DocumentService.isFileEncrypted(newFile);
          fileProperties.isAPdfPortfolio = await DocumentService.isPdfAPortfolioFileType(newFile);
          if (fileProperties.fileEncrypted) {
            file.errors.push('lang.shared.fileEncrypted' as never);
          }
          if (fileProperties.isAPdfPortfolio) {
            file.errors.push('lang.shared.isPdfAPortfolioFileType' as never);
          }
        }

        validateFile(file);
        fileProperties.dragging = false;

        if (file.errors.length) {
          state.filesError.push(file as never);
          continue;
        }

        if (file.extension.toLowerCase() !== Constants.fileImporter.PDF_EXTENSION) {
          await imageCompressor.compress(newFile);
        }

        const data: { processId: string, inscriptionId: string, type: number, formFile: any, requirementId?: string, examId?: string, meritId?: string, meritGroupId?: string, meritSubGroupId?: string } = {
          processId: state.processId,
          inscriptionId: state.inscription.id,
          type: type,
          formFile: newFile
        };

        if (data.type === FileTypes.enum.REQUIREMENT) {
          (data as any).requirementId = requirementId;
        }
        if (data.type === FileTypes.enum.CREDITABLEEXAMS) {
          (data as any).examId = examId;
        }
        if (data.type === FileTypes.enum.MERIT) {
          (data as any).meritId = meritId;
          (data as any).meritGroupId = meritGroupId;
          (data as any).meritSubGroupId = meritSubGroupId;
        }

        if (!state.periodAttachMeritsOpen) {
          const index = state.inscription.documents.length;
          state.inscription.documents.push(new InscriptionFile(file));
          addFileToInscription(data)
            .then((response) => {
              state.inscription.documents[index].id = response;
              state.inscription.documents[index].loading = false;

              if (data.type === FileTypes.enum.MERIT) {
                calcTotalScoreOnFixedScore(meritGroupId, meritId, meritSubGroupId);
              }
            })
            .catch((error) => {
              console.error(error);
              state.inscription.documents.splice(index, 1);
            });
        } else {
          const fileMeritPostInscription = {
            formFile: newFile,
            inscriptionId: state.inscription.id,
            evaluableConditionType: type,
            meritSubGroupId: meritSubGroupId,
            meritGroupId: meritGroupId,
            meritId: meritId,
            fileName: (newFile as any).name,
            fileDate: moment.utc(),
            size: (newFile as any).size,
            extension: '.' + (newFile as any).name.split('.').pop()
          };
          state.inscription.documents.push(new MeritDocumentPostInscription(fileMeritPostInscription));
          calcTotalScoreOnFixedScore(meritGroupId, meritId, meritSubGroupId);
        }
      }
    };

    const addDocument = async ($event, importer, type, fileProperties) => {
      if (isPreview.value) {
        return;
      }

      let newFile = getFileToAdd($event, importer);
      if (isFileAlreadyOnDocuments({ type: type, newFile: newFile })) {
        return;
      }

      const index = state.inscription.documents.length;
      const file = {
        evaluableConditionType: type,
        fileName: newFile.name,
        fileDate: moment.utc(),
        size: newFile.size,
        extension: '.' + newFile.name.split('.').pop(),
        loading: true
      };

      if (fileProperties) {
        fileProperties.resetValidation();
      }

      const isFileValid = fileProperties.isFileValid(file);

      if (file.extension.toLowerCase() === Constants.fileImporter.PDF_EXTENSION) {
        fileProperties.fileEncrypted = await DocumentService.isFileEncrypted(newFile);
        fileProperties.isAPdfPortfolio = await DocumentService.isPdfAPortfolioFileType(newFile);
      }

      if (!isFileValid || fileProperties.fileEncrypted || fileProperties.isAPdfPortfolio) {
        afterDrag(fileProperties);
        return;
      }

      if (file.extension.toLowerCase() !== Constants.fileImporter.PDF_EXTENSION) {
        newFile = await imageCompressor.compress(newFile);
      }

      const data = {
        processId: state.processId,
        inscriptionId: state.inscription.id,
        type: type,
        formFile: newFile
      };

      state.inscription.documents.push(new InscriptionFile(file));
      addFileToInscription(data)
        .then((response) => {
          state.inscription.documents[index].id = response;
          state.inscription.documents[index].loading = false;

          if (commonDataState.app.params.get('type') == ProcessType.enum.CALL && type === FileTypes.enum.DISABILITY) {
            if (hasNoPayExemptionTypeAndExistDisability()) {
              state.inscription.payExemption.payExemptionType = PayExemptionTypes.enum.DISABILITY;
            }
            if (state.inscription.payExemption.payExemptionType === PayExemptionTypes.enum.DISABILITY) {
              importer = { files: [newFile] };
              addDocument({ dataTransfer: null }, importer, FileTypes.enum.PAY_EXEMPTION, fileProperties);
            }
          }
        })
        .catch((error) => {
          console.log(error);
          state.inscription.documents.splice(index, 1);
        });

      if (type === FileTypes.enum.DISABILITY && hasNoPayExemptionTypeAndExistDisability()) {
        state.inscription.payExemption.payExemptionType = PayExemptionTypes.enum.DISABILITY;
      }
      if (type === FileTypes.enum.DISABILITY && state.inscription.payExemption.payExemptionType === PayExemptionTypes.enum.DISABILITY) {
        importer = { files: [newFile] };
        addDocument({ dataTransfer: null }, importer, FileTypes.enum.PAY_EXEMPTION, fileProperties);
      }
      afterDrag(fileProperties);
    };

    const getFileToAdd = (event, importer) => {
      if (!event.dataTransfer) {
        let file = importer.files[0];
        importer.value = '';
        return file;
      }
      return event.dataTransfer.files[0];
    };

    const isFileAlreadyOnDocuments = (fileData) => {
      const inscriptionDocumentLists = {
        [FileTypes.enum.DISABILITY]: disabilityDocuments,
        [FileTypes.enum.REQUIREMENT]: requirementDocuments,
        [FileTypes.enum.CREDITABLEEXAMS]: examDocuments,
        [FileTypes.enum.MERIT]: meritDocuments,
        [FileTypes.enum.PAY_EXEMPTION]: payExemptionDocuments,
        [FileTypes.enum.FEE_PAYMENT]: feePaymentDocuments
      };

      return inscriptionDocumentLists[fileData.type].value.length > 0
        && inscriptionDocumentLists[fileData.type].value.some((doc) => doc.isValidFileToUpload(fileData.newFile));
    };

    const hasNoPayExemptionTypeAndExistDisability = () => {
      const step = state.wizard.getStep(4, 0);
      return state.inscription.payExemption.payExemptionType === PayExemptionTypes.enum.NOREASON &&
        state.inscription.disabilityData.hasDisability &&
        step && (step as PayExemptionStep).payExemptions.some(payExemption => payExemption.payExemptionType === PayExemptionTypes.enum.DISABILITY);
    };

    const beforeDrag = (fileProperties) => {
      fileProperties.dragging = true;
    };

    const afterDrag = (fileProperties) => {
      fileProperties.dragging = false;
    };

    const calcTotalScoreOnFixedScore = (meritGroupId, meritId, meritSubGroupId = null) => {
      const meritToCalc = meritSubGroupId
        ? state.inscription.meritGroups.find(meritGroup => meritGroup.id === meritGroupId)
          .meritChilds.find(children => children.id === meritSubGroupId)
          .merits.find(element => element.id === meritId)
        : state.inscription.meritGroups.find(element => element.id === meritGroupId)
          .meritChilds.find(element => element.id === meritId);

      if (meritToCalc.ratingType === MeritRatingType.enum.FIXED_SCORE || meritToCalc.ratingType === MeritRatingType.enum.INTERVIEW) {
        calcTotalScoreAndSaveDraft(meritToCalc);
      }
    };

    const removeDocument = (document) => {
      if (state.periodAttachMeritsOpen) {
        const index = state.inscription.documents.indexOf(document);
        if (index >= 0) {
          state.inscription.documents.splice(index, 1);
        }
        calcTotalScoreOnFixedScore(document.meritGroupId, document.meritId, document.meritSubGroupId);
        return;
      }

      return new Promise<void>((resolve, reject) => {
        document.fileName = '';
        document.loading = true;
        removeFileFromInscription(state.inscription.id, document.id)
          .then(() => {
            const index = state.inscription.documents.findIndex(doc => doc.id === document.id);
            if (index !== -1) {
              state.inscription.documents.splice(index, 1);
              if (document.meritId) {
                calcTotalScoreOnFixedScore(document.meritGroupId, document.meritId, document.meritSubGroupId);
              }
            }
            resolve();
          }).catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    };

    const clearDocumentsPayExemption = () => {
      if (pricePayExemption.value === 0) {
        payExemptionForm.value.forEach((element) => {
          element.checkValidity();
        });
      }

      const queryList = [];
      state.removingDocuments = true;

      payExemptionDocuments.value.forEach((document) => {
        queryList.push(removeDocument(document) as never);
      });

      Promise.all(queryList).then(() => {
        state.removingDocuments = false;
      }).catch((error) => {
        console.error(error);
      });

      if (!state.inscription.paymentBox.validFileName || !state.inscription.paymentBox.validExtension || !state.inscription.paymentBox.validSize) {
        state.inscription.paymentBox.validFileName = true;
        state.inscription.paymentBox.validExtension = true;
        state.inscription.paymentBox.validSize = true;
      }

      clearDocumentsFeePayment();
    };

    const clearDocumentsFeePayment = () => {
      const queryList = [];
      feePaymentDocuments.value.forEach((document) => {
        queryList.push(removeDocument(document) as never);
      });

      Promise.all(queryList).then(() => { }).catch((error) => {
        console.error(error);
      });

      if (!state.inscription.feePaymentBox.validFileName || !state.inscription.feePaymentBox.validExtension || !state.inscription.feePaymentBox.validSize) {
        state.inscription.feePaymentBox.validFileName = true;
        state.inscription.feePaymentBox.validExtension = true;
        state.inscription.feePaymentBox.validSize = true;
      }
    };

    const onlyNumber = ($event, strict = false) => {
      const keyCode = $event.which ? $event.which : $event.keyCode;
      if (
        (keyCode < Constants.keyCodes.ZERO_KEY_CODE || keyCode > Constants.keyCodes.NINE_KEY_CODE) && strict ||
        (keyCode < Constants.keyCodes.ZERO_KEY_CODE || keyCode > Constants.keyCodes.NINE_KEY_CODE) &&
        keyCode !== Constants.keyCodes.DOT_KEY_CODE &&
        keyCode !== Constants.keyCodes.COMMA_KEY_CODE
      ) {
        $event.preventDefault();
      }
    };

    const validateForm = () => {
      if (!state.tryToSubmit) return false;

      state.wizard.clearErrors();
      const errors = InputService.validateFormRequired(inscriptionForm.value, state.wizard as Wizard);
      InputService.validateErrorCollapsibleBox(inscriptionForm.value);

      if (!state.inscription.disabilityData.hasDisability && state.inscription.payExemption.payExemptionType === PayExemptionTypes.enum.DISABILITY) {
        state.wizard.getStep(0, 4)!.error = true;
        return false;
      }

      return errors;
    };

    const onSubmit = () => {
      if (isPreview.value) {
        return;
      }

      nextTick(() => {
        notification.initialize();
      });

      state.tryToSubmit = true;

      if (!validateForm()) {
        state.wizard.groupActive = state.wizard.structure.find((group: StepGroup) => {
          const stepsWithError = group.steps.find((step: any) => step.error);
          if (stepsWithError) {
            state.wizard.stepActive = stepsWithError.order;
          }
          return stepsWithError != null;
        }).type;
        state.haveBeenAnyError = true;
        InputService.validateErrorCollapsibleBox(inscriptionForm.value);
        return;
      }

      state.loading = true;

      if (state.periodAttachMeritsOpen) {
        state.modalMeritsVisible = true;
        return;
      }

      state.modalVisible = true;
    };

    const putMerits = async () => {
      state.modalMeritsVisible = false;
      state.showLoader = true;
      const meritsDocuments = state.inscription.documents.filter((doc) => doc.type === FileTypes.enum.MERIT && !doc.uploader);

      for (let index = 0; index < meritsDocuments.length; index++) {
        try {
          await attachMeritsFiles(meritsDocuments[index].toServer(), state.inscription.hasRepresentative ? state.inscription.representative.nif : state.inscription.personalDataDetails.NIF);
        } catch (error) {
          state.loading = false;
          state.showLoader = false;
          state.showError = true;
        }
      }

      try {
        if (state.inscription.hasCryptoSignature) {
          state.inscription.cryptoSignature = commonDataState.app.toServerCryptoSignature();
        }
        await finishAttachMerits(
          state.inscription.hasRepresentative ? state.inscription.representative.nif : state.inscription.personalDataDetails.NIF,
          state.inscription as any
        );
        state.submited = true;
        state.loading = false;
        state.showLoader = false;
      } catch (error) {
        console.log(error);
      }
    };

    const putInscription = () => {
      state.modalVisible = false;
      state.showLoader = true;
      if (state.inscription.hasCryptoSignature) {
        state.inscription.cryptoSignature = commonDataState.app.toServerCryptoSignature();
      }
      const request = mustPayInscriptionOnline() ? payInscription : finishInscription;
      request(state.inscription as any)
        .then((response: any) => {
          if (response.data.paymentOrder && response.data.paymentOrder.length === 42) {
            getCaixaPaymentData(state.inscription.id, response.data.paymentOrder).then((responsePaymentInfo: any) => {
              state.paymentGttCaixaData = new PaymentDataGttCaixa(responsePaymentInfo.data);
              window.location.assign(state.paymentGttCaixaData.url);
            });
          }

          if (response.data.paymentOrder && response.data.paymentOrder.length !== 42) {
            getRedsysPaymentData(state.inscription.id, response.data.paymentOrder).then((responsePaymentInfo: any) => {
              state.paymentRedsysData = new PaymentDataRedsys(responsePaymentInfo.data);
              nextTick(() => {
                paymentFormRedsys.value.submit();
              });
            });
          }

          if (!response.data.paymentOrder) {
            window.history.replaceState('string', '', `${window.location}/finishedProcess`);
            state.submited = true;
            state.loading = false;
            state.showLoader = false;
          }
        })
        .catch(() => {
          state.loading = false;
          state.showLoader = false;
          state.showError = true;
        });
    };

    const closeModal = () => {
      state.modalVisible = false;
      state.modalMeritsVisible = false;
      state.showExitModal = false;
      state.loading = false;
    };

    const goToStep = ($event) => {
      validateForm();
      state.wizard.groupActive = +($event.target.closest('.inscription-indicator__element').getAttribute('data-menu-group'));
      state.wizard.stepActive = +($event.target.closest('.inscription-indicator__element-link').getAttribute('data-menu-step'));
    };

    const saveDraft = () => {
      if (isPreview.value || state.periodAttachMeritsOpen) {
        return;
      }

      postInscriptionAutoSave(state.inscription as any)
        .then(() => { })
        .catch(() => { });
    };

    const changeOficio = (merit) => {
      if (merit.ratingType === MeritRatingType.enum.FIXED_SCORE || merit.ratingType === MeritRatingType.enum.INTERVIEW) {
        merit.calcTotalScore(meritDocuments.value);
      }
      if (!merit.allowUserOficio) {
        merit.userOficioComment = null;
      }
      saveDraft();
    };

    const checkDocumentsInMerit = (merit) => {
      return meritDocuments.value.find(element => element.meritId === merit.id);
    };

    const clickMeritInputDocument = (meritIndex, groupIndex, subGroupIndex = '') => {
      const elementToClick = subGroupIndex !== '' ? `merit${meritIndex}${groupIndex}${subGroupIndex}` : `merit${meritIndex}${groupIndex}`;
      nextTick(() => {
        meritRefs.value.find((meritRef: { name: string, el: HTMLElement }) => meritRef.name === elementToClick)?.el.click();
      });
    };

    const updateMeritGroupScoreOnMeritScoreChange = (merit) => {
      const meritGroup = state.inscription.meritGroups.find(group => group.id === merit.meritGroupId);
      meritGroup.totalGroupScore();
    }

    const updateMeritSubGroupScoreOnMeritScoreChange = (merit) => {
      const meritGroup = state.inscription.meritGroups.find(group => group.id === merit.meritGroupId);
      meritGroup.totalGroupScore();
      const meritSubGroup = meritGroup.meritChilds.find(subGroup => subGroup.id === merit.subGroupId);
      meritSubGroup.totalSubGroupScore();
    }

    const calcTotalScoreAndSaveDraft = (merit) => {
      merit.calcTotalScore(meritDocuments.value);
      if (merit.meritGroupId) {
        updateMeritGroupScoreOnMeritScoreChange(merit);
      }
      if (merit.subGroupId) {
        updateMeritSubGroupScoreOnMeritScoreChange(merit);
      }
      saveDraft();
    };

    const jointMerits = (meritsInStructure, meritsInInscription) => {
      for (let i = 0; i < meritsInStructure.length; i++) {
        for (let z = 0; z < meritsInStructure[i].meritChilds.length; z++) {
          for (let x = 0; x < meritsInInscription.length; x++) {
            for (let q = 0; q < meritsInInscription[x].merits.length; q++) {
              const meritChildInStructure = meritsInStructure[i].meritChilds[z];
              const meritInInscription = meritsInInscription[x].merits[q];

              if (meritChildInStructure.type === BaseMeritsType.enum.MERIT && meritChildInStructure.id === meritInInscription.id) {
                meritChildInStructure.allowUserOficio = meritInInscription.allowUserOficio;
                meritChildInStructure.userScore = meritInInscription.userScore;
                meritChildInStructure.userOficioComment = meritInInscription.userOficioComment;
              }

              if (meritChildInStructure.type === BaseMeritsType.enum.MERITSUBGROUP) {
                meritChildInStructure.merits.forEach(meritInSubGroup => {
                  if (meritInSubGroup.id === meritsInInscription[x].merits[q].id) {
                    meritInSubGroup.allowUserOficio = meritsInInscription[x].merits[q].allowUserOficio;
                    meritInSubGroup.userScore = meritsInInscription[x].merits[q].userScore;
                    meritInSubGroup.userOficioComment = meritsInInscription[x].merits[q].userOficioComment;
                  }
                });
              }
            }
          }
        }
      }
    };

    const manageCallWithReferences = () => {
      if (!isReferencesNotNull()) {
        return;
      }

      const stepReferences = (state.wizard.getStep(0, 2) as ProcessInfoStep).references;

      const inscriptionReferencesMap:  Map<string, IInscriptionReference> = new Map(
        state.inscription.references.map(ref => [ref.referenceId, ref])
      );

      stepReferences.forEach(stepRef => {
        const match = inscriptionReferencesMap.get(stepRef.id);
        if (match) {
          stepRef.order = match.order;
          stepRef.selected = true;
        }
      })
    };

    const mountWizard = (responseAll) => {
      const indexInscription = 0;
      const indexStructure = 1;
      const indexProcessConfigurationPayExemptions = 2;
      const indexProcessConfigurationAuthorization = 3;
      const notFound = -1;

      (state.inscription as any) = new Inscription(responseAll[indexInscription].data, responseAll[indexStructure].data.autoScaling);
      state.wizard = new Wizard(responseAll[indexStructure].data.structure, responseAll[indexStructure].data.autoScaling, responseAll[indexProcessConfigurationPayExemptions].data, responseAll[indexProcessConfigurationAuthorization].data);

      manageCallWithReferences()

      const turnTypes = responseAll[indexStructure].data.turnTypes;
      if (turnTypes.length === 1) {
        state.inscription.contactData.inscriptionTurn = turnTypes[0];
      }
      
      if (disabilityTurnSelected.value) {
        state.inscription.disabilityData.hasDisability = true;
      }

      const indexMerits = state.wizard.getMeritsIndexStructure();
      const indexExams = state.wizard.getExamsIndexStructure();

      if (state.inscription.address.province) {
        getMasterDataMunicipalities(state.inscription.address.province).then((municipalities: any) => {
          state.municipalities = MunicipalitiesService.setMunicipalities(municipalities.data, state.inscription.address.municipality);
          nextTick(() => {
            InputService.checkValueAndUpdateInput(inscriptionForm.value);
          });
        }).catch((error) => {
          console.error(error);
        });
      }

      state.periodAttachMeritsOpen = responseAll[indexStructure].data.attachMeritsPeriodOpen;
      if (state.periodAttachMeritsOpen) {
        state.wizard.groupActive = Constants.inscription.STEP_MERIT;
        state.inscription.legalConsent.hasAccepted = false;
      }

      state.inscription.hasAuthorizationProcess = responseAll[indexStructure].data.hasAuthorization;
      state.inscription.hasCryptoSignature = responseAll[indexStructure].data.hasCryptoSignature;
      state.inscription.processTitle = responseAll[indexStructure].data.processTitle;
      state.inscription.processEntityName = responseAll[indexStructure].data.entityName;
      state.inscription.processHasFeePayment = responseAll[indexStructure].data.hasFeePayment;
      state.inscription.processHasOnlinePayment = responseAll[indexStructure].data.hasOnlinePayment;
      state.inscription.processHasPasarelaPayment = responseAll[indexStructure].data.hasPasarelaPayment;
      state.inscription.processPaymentType = responseAll[indexStructure].data.feePaymentType;
      state.inscription.requirements = state.wizard.structure[indexStructure].steps.map((step: any) => ({
        id: step.id
      }));

      setFilterReferencesData();
      state.filter.setFilterElements(ReferencesFilters);

      if (responseAll[indexStructure].data.processEndDate !== null) {
        state.inscription.processEndDate = responseAll[indexStructure].data.processEndDate;
      }

      if (indexMerits !== notFound) {
        if (state.wizard.structure[indexMerits].steps.some((merit: any) => merit.type === Constants.inscription.POST_MERIT_STEP)) {
          handleMeritsPostInscription(state.wizard.structure[indexMerits].steps[0]);
        } else {
          state.showMerits = true;
          handleMeritsPostInscription(state.wizard.structure[indexMerits].steps[0]);
          jointMerits(state.wizard.structure[indexMerits].steps, state.inscription.meritGroups);
          state.inscription.meritGroups = state.wizard.structure[indexMerits].steps;
          state.inscription.meritGroups.forEach(meritGroup => {
            meritGroup.meritChilds.forEach(meritChild => {
              if (meritChild.type === BaseMeritsType.enum.MERIT) {
                meritChild.calcTotalScore(meritDocuments.value);
              }
              if (meritChild.type === BaseMeritsType.enum.MERITSUBGROUP) {
                meritChild.merits.forEach(merit => {
                  merit.calcTotalScore(meritDocuments.value);
                });
              }
            });
          });
          if (state.wizard.hasAutoScaling) {
            state.wizard.structure[indexMerits].steps.push({ order: state.wizard.structure[indexMerits].steps.length, name: 'lang.shared.summary' } as any);
          }
        }
      }

      if (indexExams !== notFound) {
        state.inscription.creditableExams = (state.wizard.structure[indexExams].steps[0] as ExamStep).creditableExams;
      }

      state.interfazLoaded = true;
      state.legalHTMLcontent = (state.wizard.getStep(1, 0) as LegalStep)?.legalConsentText;
      state.rgpdHTMLcontent = (state.wizard.getStep(1, 0) as LegalStep)?.dataProtectionText;

      if (state.inscription.hasAuthorizationProcess && !state.periodAttachMeritsOpen) {
        state.authorizationsHTMLcontent = (state.wizard.getStep(0, 3) as AuthorizarionStep)?.authorizationText;
        state.refuseHTMLcontent = (state.wizard.getStep(0, 3) as AuthorizarionStep)?.refuseText;
      }

      if (isPreview.value) {
        state.inscription.authorization.refuseAuthorization = false;
      }

      state.inscription.setPaymentMethod(pricePayExemption.value);

      nextTick(() => {
        InputService.checkValueAndUpdateInput(inscriptionForm.value);
        dropdown.initialize();
      });
    };

    const onTurnChange = () => {
      manageDisability();
      if (hasInscriptionReferences.value) {
        resetReferenceSelection();
      }
      setFilterReferencesData();
      updateInscriptionReferences();
    }
    
    const resetReferenceSelection = () => {
      (state.wizard.getStep(0, 2) as ProcessInfoStep).references = (state.wizard.getStep(0, 2) as ProcessInfoStep).references.map(ref=> {
        return {
         ... ref,
         selected: false,
         order: null
        }
       });
    };

    const getInscriptionAction = () => {
      if (isPreview.value) {
        return [
          getInscriptionPreview(state.processId),
          getInscriptionStructure(state.processId, isPreview.value),
          getProcessesConfigurationPayExemptionList(),
          getProcessesConfigurationAuthorizationList()
        ];
      }
      return [
        getInscriptionById(state.idInscription),
        getInscriptionStructure(state.processId, isPreview.value),
        getProcessesConfigurationPayExemptionList(),
        getProcessesConfigurationAuthorizationList()
      ];
    };

    const getMasterData = () => {
      getMasterDataCountries().then((responseCountries: any) => {
        state.countries = responseCountries.data;
      }).catch((error) => {
        console.error(error);
      });
      getMasterDataAutonomousCommunity().then((responseAutonomousCommunity: any) => {
        state.autonomousCommunityList = OrderSelect.prepareDataNotArray(responseAutonomousCommunity.data);
      }).catch((error) => {
        console.error(error);
      });
      getMasterDataStreetTypes().then((responseDataStreetTypes: any) => {
        state.streetTypes = OrderSelect.prepareDataNotArray(responseDataStreetTypes.data);
      }).catch((error) => {
        console.error(error);
      });
      getMasterDataProvinces().then((responseProvinces: any) => {
        state.provinces = OrderSelect.prepareDataNotArray(responseProvinces.data);
      }).catch((error) => {
        console.error(error);
      });
      getMasterDataNationalities().then((responseNationalities: any) => {
        state.nationalities = responseNationalities.data;
      }).catch((error) => {
        console.error(error);
      });

      Promise.all(getInscriptionAction()).then((responseAll) => {
        mountWizard(responseAll);
      });
    };

    const handleMeritsPostInscription = (meritStep) => {
      if (meritStep instanceof AdminPreviewInscriptionMeritStep || meritStep instanceof PostMeritStep) {
        state.allowMeritsPostinscription = meritStep.allowPostInscriptionMeritPresentation;
        (state.meritPresentationStartDate as any) = meritStep.meritPresentationStartDate;
        (state.meritPresentationEndDate as any) = meritStep.meritPresentationEndDate;
      }
    };

    const getAllData = () => {
      if (isPreview.value) {
        getMasterData();
      } else {
        commonDataState.app.getProfile().then(async () => {
          if (commonDataState.app.profile) {
            commonDataState.app.profile.authenticationDate = moment.unix(commonDataState.app.profile.auth_time);
            commonDataState.app.profile.certificateType = 'lang.inscriptions.physicalPerson';
            commonDataState.app.profile.securityLevel = 'lang.inscriptions.medium';

            getIP().then((responseIp: any) => {
              commonDataState.app.profile.ip = responseIp.data;
            }).catch((error) => {
              console.error(error);
            });

            state.isRedirecting = false;
            const applicantData = {
              personalDataDetails: {
                nif: commonDataState.app.params.get('nif'),
                name: commonDataState.app.params.get('name'),
                firstSurname: commonDataState.app.params.get('firstSurname'),
                secondSurname: commonDataState.app.params.get('secondSurname')
              },
            }

            const representative = await loadRepresentative();
            if (representative) {
              await deleteRepresentativeFromRepo();
            }

            const newInscriptionIdCommand = {
              processId: state.processId,
              nif: commonDataState.app.profile.nickname,
              applicantData: applicantData.personalDataDetails.nif ? applicantData : null,
              representativeData: representative ? representative.toServer() : null,
              formFile: representative ? representative.authorizationFile : null
            };

            getNewInscriptionId(newInscriptionIdCommand)
              .then((response: any) => {
                state.idInscription = response.data.id;
                getMasterData();
              })
              .catch((error) => {
                if (error.response.data === "UserAlreadyRegistered") {
                  state.alreadyRegistered = true;
                }
                if (error.response.data === "UserNotRepresentable") {
                  state.notRepresentable = true;
                }
                if (error.response.data === "RepresentativeIsApplicant") {
                  state.representativeIsTheSame = true;
                }
              });
          } else {
            state.isRedirecting = true;
            commonDataState.app.login();
          }
        })
          .catch((error) => {
            console.error(error);
          });
      }
    };

    const loadRepresentative = async (): Promise<Representative | null> => {
      try {
        const representative = await representativeRepository.getRepresentative();
        if (representative) {
          return representative
        }
        return null;
      } catch (error) {
        console.error(error);
      }
    };

    const deleteRepresentativeFromRepo = async () => {
      await representativeRepository.deleteRepresentative();
    };

    const mustPayInscriptionOnline = () => {
      state.inscription.setPaymentMethod(pricePayExemption.value);
      return state.inscription.paymentMethod === PaymentMethod.enum.ONLINE && pricePayExemption.value > 0;
    };

    const downloadDocument = (document) => {
      DocumentService.download(document);
    };

    const checkModalServiceStopLocalStorage = () => {
      const serviceStopItem = localStorage.getItem(serviceStopLocalStorageKey);
      if (!serviceStopItem) {
        return;
      }
      const serviceStopItemData = JSON.parse(serviceStopItem);
      if (moment() > moment(serviceStopItemData.expires)) {
        localStorage.removeItem(serviceStopLocalStorageKey);
      }
    };

    const downloadInscriptionJustify = async () => {
      try {
        const document = await getInscriptionJustify(state.inscription.id);
        DocumentService.download(new InscriptionDocument(document));
      } catch (error) {
        console.error(error);
      }
    };

    const formatDate = (date: Date | string) => {
      if (!date) {
        return '';
      }

      if (date instanceof Date) {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        return `${day}/${month}/${year}`
      }

      const dateStringRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

      if (dateStringRegex.test(date)) {
        const newDate = new Date(date);
        const day = newDate.getDate();
        const month = newDate.getMonth() + 1;
        const year = newDate.getFullYear();
        return `${day}/${month}/${year}`
      }

    };

    const onReferenceClick = (referenceId: string) => {
      const referenceUpdated =  (state.wizard.getStep(0, 2) as ProcessInfoStep).references.find((ref: ICallReference) => ref.id === referenceId);
      referenceUpdated.order = referenceUpdated.selected ? selectedReferences.value.length : null;

      if (referenceUpdated.order === null) {
        selectedReferences.value.forEach((reference, index) => {
          if (reference.selected) {
            reference.order = index + 1;
          }
        });
      }

      (state.wizard.getStep(0, 2) as ProcessInfoStep).references = referencesSorted.value;
      updateInscriptionReferences();
      setFilterReferencesData();
      saveDraft();
    };

    const onReferenceMove = (evt) => {
      return evt.dragged.classList.contains('draggable') && (!evt.related || evt.related.classList.contains('draggable'));
    };

    const onDragEnd = (evt) => {
      if (!evt.clone.classList.contains('draggable')) {
        return;
      }

      const newOrderedReferences = new Map(filteredReferences.value.map((item, index) => [item.id, index]));
      
      (state.wizard.getStep(0, 2) as ProcessInfoStep).references.forEach(item => {
        if (newOrderedReferences.has(item.id)) {
          item.order = newOrderedReferences.get(item.id) + 1;
        }
      });

      (state.wizard.getStep(0, 2) as ProcessInfoStep).references = referencesSorted.value;
      updateInscriptionReferences();
      saveDraft();
    };

    const onOrderChange = (referenceWithOrderChanged) => {
      const newIndex = referenceWithOrderChanged.order - 1;
    
      if (newIndex < 0 || isNaN(newIndex) || newIndex >= selectedReferences.value.length ) {
        referenceWithOrderChanged.order = null;
        draggableOptions.isDraggableDisabled = false;
        return;
      }
    
      const currentIndex = selectedReferences.value.findIndex((ref: ICallReference) => ref.id === referenceWithOrderChanged.id);
      if (currentIndex === -1) {
        draggableOptions.isDraggableDisabled = false;
      }

      selectedReferences.value.splice(currentIndex, 1);
    
      selectedReferences.value.splice(newIndex, 0, referenceWithOrderChanged);
    
      selectedReferences.value.forEach((ref, index) => {
        ref.order = index + 1;
      });

      (state.wizard.getStep(0, 2) as ProcessInfoStep).references = referencesSorted.value;
      updateInscriptionReferences();
      setFilterReferencesData();
      draggableOptions.isDraggableDisabled = false;
      saveDraft();
    };
    
    const setFilterReferencesData = () => {
      state.filter.setData(referencesByTurn.value);
    };

    const onInputFilter = (value) => {
      state.filter = value;
      setFilterReferencesData();
    };

    const updateInscriptionReferences = () => {
      state.inscription.references = (state.wizard.getStep(0, 2) as ProcessInfoStep).references
      .filter(ref => ref.selected)
      .map(ref => ({ referenceId: ref.id, order: ref.order }));
    }

    const isReferencesNotNull = () => {
      return Boolean((state.wizard.getStep(0, 2) as ProcessInfoStep) && (state.wizard.getStep(0, 2) as ProcessInfoStep).references !== null);
    }

    // shared properties
    const showMandatoryCookies = ref(false);
    const showAnalysisCookies = ref(false);
    const showModalConfigurateCookies = ref(false);
    const showServiceStopModal = ref(false);
    const dontShowAgainStopServiceModalAgain = ref(false);
    const serviceStopLocalStorageKey = 'dontShowServiceStopModal';
    const serviceStopEndDate = moment('2024-05-15T17:00:00');
    const representativeRepository = new RepresentativeRepository();
    // view properties
    const isPreview = ref(commonDataState.app.params.get('preview') !== null);
    const state = reactive({
      legalHTMLcontent: {} as MultiLanguage,
      rgpdHTMLcontent: {} as MultiLanguage,
      authorizationsHTMLcontent: {} as MultiLanguage,
      refuseHTMLcontent: {} as MultiLanguage,
      processId: commonDataState.app.params.get('id') ?? '',
      idInscription: '',
      processTypeSelected: commonDataState.app.params.get('type') ?? 0,
      inscription: {} as any,
      interfazLoaded: false,
      inscriptionStructure: [],
      pageTitle: '',
      wizard: {} as Wizard,
      showError: false,
      loading: false,
      tryToSubmit: false,
      submited: false,
      provinces: {},
      countries: [],
      municipalities: [],
      autonomousCommunityList: {},
      streetTypes: {},
      today: moment(),
      authorizationEntities: [],
      haveBeenAnyError: false,
      removingDocuments: false,
      alreadyRegistered: false,
      notRepresentable: false,
      representativeIsTheSame: false,
      isRedirecting: false,
      spainCode: Constants.country.SPAIN_CODE,
      fiveZeros: Constants.postalCode.FIVE_ZEROS,
      modalVisible: false,
      modalMeritsVisible: false,
      periodAttachMeritsOpen: false,
      showLoader: false,
      loadingStreetTypes: false,
      showSteps: true,
      showExitModal: false,
      allowMeritsPostinscription: false,
      meritPresentationStartDate: null,
      meritPresentationEndDate: null,
      paymentRedsysData: {} as PaymentDataRedsys,
      paymentGttCaixaData: {} as PaymentDataGttCaixa,
      maxYears: Constants.inscription.MAX_YEARS,
      maxFullYears: Constants.inscription.MAX_FULL_YEARS,
      maxUserOficioComment: Constants.inscription.MAX_USER_OFICIO_COMMENT,
      momentFormat: {
        // Date to String
        stringify: (date) => {
          return date && (i18n as any).locale ? moment(date).format(Constants.format.L) : ''
        },
        // String to Date
        parse: (value) => {
          return value ? moment(value, Constants.format.L).toDate() : null
        }
      },
      showMerits: false,
      filesError: [],
      nationalities: [],
      filter: ref(new Filter()),
      filters: ReferencesFilters,
    });

    const inscriptionForm = ref();
    const payExemptionForm = ref();
    const paymentFormRedsys = ref();
    const datepicker = ref();
    const meritRefs: Ref<[{ name: string, el: HTMLElement }] | []> = ref([]);
    const examsRefs = ref({});
    const disabilityFileImporterRef = ref();
    const feePaymentFileImporterRef = ref();
    const payFileImporterRef = ref();
    const requirementsRef = ref([]);
    const datePickerTriggerRefRef = ref();
    const datepickerOptions = {
      uid: 'savia-datepicker',
      flow: ref(['year', 'month', 'day']).value,
      maxRetirementAge: moment().subtract(Constants.maximumInscriptionCandidateAge, 'years').add(1, 'day').toString(),
      minUnderSixteen: moment().subtract(Constants.minimumInscriptionCandidateAge, 'years').toString(),
      yearRange: [moment().subtract(Constants.maximumInscriptionCandidateAge, 'years').year().toString(), moment().subtract(Constants.minimumInscriptionCandidateAge, 'years').year().toString()],
      menuPosition: () => ({ top: 52, left: 0 })
    };

    const draggableOptions: {isDraggableDisabled: boolean, isDragging: boolean} = reactive({
      isDraggableDisabled: false,
      isDragging: false,
    });

    const clearDatePicker = () => {
      state.inscription.personalDataDetails.dateOfBirth = {};
    };

    const updateCommonData = (state: ICommonDataState) => {
      commonDataState.availableLanguajes = state.availableLanguajes;
      commonDataState.cookie = state.cookie;
      commonDataState.headerConfig = state.headerConfig;
      commonDataState.app = state.app;
      commonDataState.locale = state.locale;

      getAllData();
    };

    // composables
    const useCommonDataDependencies = {
      updateCommonData,
      getHeaderConfiguration,
      getFeatureFlag,
      getClientAvailableLanguajes,
    };
    const { loadCommonData } = useCommonData(useCommonDataDependencies);

    // lifecycle hooks
    onMounted(() => {
      loadCommonData();
      checkModalServiceStopLocalStorage();
      showServiceStopModal.value = commonDataState.app.isServiceStopActive && (!localStorage.getItem(serviceStopLocalStorageKey));
    });

    onBeforeUpdate(() => {
      examsRefs.value = [];
      meritRefs.value = [];
    })


    return {
      // dependencies
      t,
      // states
      ...toRefs(commonDataState),
      // computed properties
      currentLanguage,
      lastLogin,
      breadcrumOrigin,
      pageTitle,
      anyError,
      stepsWithError,
      disabilityDocuments,
      requirementDocuments,
      meritDocuments,
      examDocuments,
      payExemptionDocuments,
      feePaymentDocuments,
      disabilityTurnSelected,
      autonomousCommunityVissible,
      isLoadingDocument,
      totalPoints,
      datepickerFormat,
      underSixteen,
      retirementAge,
      pricePayExemption,
      filteredMerits,
      examInscriptionSteps,
      filteredPaymentMethods,
      filteredMeritGroupsForSummary,
      filteredReferences,
      hasInscriptionReferences,
      referencesByTurn,
      referencesOnTurn,
      isInvalidReferencesCheckbox,
      selectedReferences,
      // methods
      clearDatePicker,
      saveCookies,
      closeModalConfigurateCookies,
      acceptAllCookies,
      declineAllCookies,
      changeLocal,
      formatDate,
      saveDraft,
      refreshStreeTypes,
      onDatePickerChange,
      onDatePickerTextChange,
      onInputDateFocus,
      onInputDateBlur,
      onInputFocus,
      onInputBlur,
      changedCountry,
      changedProvince,
      toShowSteps,
      openModalExit,
      exitInscription,
      manageDisability,
      onSelectFocus,
      onSelectBlur,
      onRadioClick,
      removeFileError,
      validateFile,
      calcTotalScoreAndSaveDraft,
      calcTotalScoreOnFixedScore,
      removeDocument,
      clearDocumentsPayExemption,
      clearDocumentsFeePayment,
      onlyNumber,
      validateForm,
      onSubmit,
      mustPayInscriptionOnline,
      downloadDocument,
      putMerits,
      putInscription,
      addMultipleDocuments,
      beforeDrag,
      afterDrag,
      getFileToAdd,
      isFileAlreadyOnDocuments,
      hasNoPayExemptionTypeAndExistDisability,
      addDocument,
      jointMerits,
      closeModal,
      goToStep,
      changeOficio,
      checkDocumentsInMerit,
      clickMeritInputDocument,
      handleMeritsPostInscription,
      mountWizard,
      getInscriptionAction,
      getMasterData,
      getAllData,
      downloadInscriptionJustify,
      onReferenceClick,
      onOrderChange,
      onTurnChange,
      onInputFilter,
      manageCallWithReferences,
      resetReferenceSelection,
      updateInscriptionReferences,
      isReferencesNotNull,
      // shared view properties
      showServiceStopModal,
      dontShowAgainStopServiceModalAgain,
      serviceStopEndDate,
      showMandatoryCookies,
      showAnalysisCookies,
      showModalConfigurateCookies,
      // view properties
      state,
      inscriptionForm,
      isPreview,
      datepicker,
      ...toRefs(draggableOptions),
      onReferenceMove,
      onDragEnd,
      // enums
      Gender,
      InscriptionTurn,
      MeritGroupType,
      MeritRatingType,
      StepGroupTypes,
      ReserveType,
      FamilyType,
      FileTypes,
      Languages,
      PayExemptionTypes,
      BaseMeritsType,
      PaymentMethod,
      PaymentType,
      // constans
      spainCode: Constants.country.SPAIN_CODE,
      fiveZeros: Constants.postalCode.FIVE_ZEROS,
      datepickerOptions,
      // refs
      examsRefs,
      meritRefs,
      disabilityFileImporterRef,
      feePaymentFileImporterRef,
      payFileImporterRef,
      requirementsRef,
      datePickerTriggerRefRef,
      payExemptionForm,
      paymentFormRedsys,
    };
  },
});

const vueApp = createApp(InscriptionComponent);
vueApp.component('datepicker', DatePicker);
vueApp.use(i18n);
vueApp.config.compilerOptions.whitespace = 'preserve';
vueApp.mount(Constants.APP);